import ko from '@/locales/ko.json'
import vi from '@/locales/vi.json'

export default {
  'ko': ko,
  'vi': vi
}
